<template>
    <div class="container" id="signin">
        <div class="row navbar-uli justify-content-between">
            <div class="col-6 text-left">
                <a href=""><i class="fas fa-home"></i></a>
            </div>
            <div class="col-6 text-right">
                <a href="/login">Entrar</a>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col logo-uli">
                <img :src="brandImage()">
            </div>
        </div>
        <div class="row justify-content-center total-signin">
            <div class="col-12 text-center">
                <h1>Crie sua conta</h1>
            </div>
            <form autocomplete="on">
                <div class="col-12">
                    <input class="form-control" type="email" name="email" id="email" v-model="signin.email" placeholder="Digite seu e-mail" required>
                </div>
                <div class="col-12">
                    <input class="form-control" :type="showPassword ? 'text' : 'password'" name="senha" id="senha" v-model="signin.password" placeholder="Escolha uma senha">
                    <img @click="passwordReveal" v-if="showPassword" class="password-icon" src="../assets/img/eye-regular.svg" alt="">
                    <img @click="passwordReveal" v-else class="password-icon" src="../assets/img/eye-slash-regular.svg" alt="">
                </div>
                <template v-if="errorMessage">
                    <div class="col-12 error-alert">
                        {{errorMessage}}
                    </div>
                </template>
                <div class="col-12">
                    <button @click.prevent="handleNewUser" class="btn btn-primario">Criar</button>
                </div>
            </form>
        </div>
        <footer>
            <div class="row justify-content-center">
                <div class="col-12">
                    <p><a href="/termos-de-uso">Termos de uso</a> - <a href="/privacidade">Política de Privacidade</a></p>
                    <p>www.ulisite.com - Cnpj 32.725.793/0001-0</p>
                    <p>(17) 3223 5208</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: "signin",
    data(){
        return{
            signin:{
                email: '',
                password: '',
            },
            errorMessage: '',
            showPassword: false,
            ROOT_API: null
        }
    },
    beforeCreate(){
        if(this.$session.exists()){
            this.$router.push('/wizard');
        }
    },
    created(){
        this.ROOT_API = process.env.ROOT_API;
        this.brandImage()
    },
    methods:{
        handleNewUser,
        passwordReveal,
        registerUser,
        startSession,
        createSite,
        brandImage
    },
}
function brandImage(){
    let url = window.location.hostname;
    if(url === 'painel.sitejet.com.br'){
        return 'https://sitejet.com.br/img/Logo-Sitejet.png'
    }else{
        return '/static/img/ulisite2x.6975043.png'
    }
}
function passwordReveal() {
    this.showPassword = !this.showPassword
}
function handleNewUser(){
    this.errorMessage = ''
    if(this.signin.email.length > 7){
        this.registerUser()
    }
}
function registerUser(){
    let newUser = this.signin
    axios ({
        method: 'post',
        url: this.ROOT_API+'/api/account/create',
        data:  newUser,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(response => {
        console.log(response)
        if(response.data.status == 1){
            this.$session.start()
            this.startSession(response)
        }else if(response.data.status == 0){
            if(response.data.error == "email_exists"){
                this.errorMessage = 'E-mail já cadastrado'
            }
        }
    })
    .catch(function (response) {
        console.log(response)
    })
}
function startSession(response){
    this.$session.set('jwt', response.data.token)
    this.$session.set('userEmail', response.data.email)
    this.createSite()
}
function createSite(){
    let totalData = ''
    let token = this.$session.get('jwt')
    axios ({
        method: 'get',
        url: this.ROOT_API+'/api/site/create',
        data:  totalData,
        headers: {
            'Authorization': 'Bearer '+token,
            'Content-Type': 'application/x-www-form-urlencoded' 
        }
    })
    .then(response => {
        this.$session.set('siteId', response.data.siteId)
        this.$session.set("welcome", true)
        setTimeout(() => {
            this.$router.push('/wizard')
        }, 500);
    })
    .catch(response => {
        console.log('Erro ao gerar ID do site '+ response)
    })
}
</script>

<style scoped>
.navbar-uli{
    padding-top: 11px;
    margin-bottom: 10px;
}
.navbar-uli a{
    color: #000;
    font-size: 16px;
}
.navbar-uli a:hover{
    text-decoration: none
}
.logo-uli img {
  max-height: 118px;
  margin-top: 14px;
  margin-bottom: 20px;
  max-width: 300px;
}
.total-signin h1{
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
}
form{
    width: 80%;
    max-width: 345px;
}
form button{
    width: 170px;
    height: 45px;
    font-size: 16px;
    font-weight: 700;
    margin: 12px 0 32px;
}
input[type=email], input[type=password], input[type=text]{
    margin: 0 0 18px 0;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    padding: 6px 0 0 0;
}
input[type=password]{
    font-size: 24px;
}
input[type=password], input[type=text]{
    padding-right: 30px;
}
input[type=email]::placeholder, input[type=password]::placeholder, input[type=text]::placeholder  { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  font-size: 16px;
  opacity: 1; /* Firefox */
}

input[type=email]:-ms-input-placeholder, input[type=password]:-ms-input-placeholder, input[type=text]:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #000;
  font-size: 16px;
}

input[type=email]::-ms-input-placeholder, input[type=password]::-ms-input-placeholder, input[type=text]::-ms-input-placeholder { /* Microsoft Edge */
  color: #000;
  font-size: 16px;
}
.password-icon{
    height: 16px;
    position: absolute;
    right: 20px;
    top: 14px;
}
.password-icon:hover{
    cursor: pointer;
}
.error-alert{
    color: #F00;
    font-size: 11px;
}
footer p{
    color: #333333;
    margin-bottom: 0;
    font-size: 11px;
    line-height: 14px;
    font-family: 'Open Sans', sans-serif;        
}
footer a{
    color: #333333
}
footer a:hover{
    color: #333333
}
footer a:visited{
    color: #333333
}
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue